/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import ImportModel from 'cio/models/import';
import exportUrl, { ExportType, EVENT_NAMES } from 'cio/utils/imports/export-url';
import ApiService from 'cio/services/api';
import AnalyticsService from 'cio/services/analytics';
import Ember from 'ember';

interface ImportCsvExportDropdownArgs {
  import: ImportModel;
  label: string;
  disabled?: boolean;
}

export default class ImportCsvExportDropdown extends Component<ImportCsvExportDropdownArgs> {
  @service api!: ApiService;
  @service analytics!: AnalyticsService;

  downloadImport = (type: ExportType) => async () => {
    let url = this.exportUrlForType(type);

    if (!url) {
      return;
    }

    try {
      let response = await this.api.post(url);
      if (!Ember.testing) {
        window.location = response.url;
      }
      this.analytics.track('import', EVENT_NAMES[type], { model: this.args.import });
    } catch {
      // ignore errors
    }
  };

  items = [
    {
      label: 'Original',
      action: this.downloadImport(ExportType.Original),
      disabled: !this.args.import.isOriginalAvailable || !this.exportUrlForType(ExportType.Original),
    },
    {
      label: 'Warnings',
      action: this.downloadImport(ExportType.Warnings),
      disabled: this.args.import.isExpired || !this.exportUrlForType(ExportType.Warnings),
    },
    {
      label: 'Errors',
      action: this.downloadImport(ExportType.Errors),
      disabled: this.args.import.isExpired || !this.exportUrlForType(ExportType.Errors),
    },
    {
      label: 'Import',
      action: this.downloadImport(ExportType.Import),
      disabled: this.args.import.isExpired || !this.exportUrlForType(ExportType.Import),
    },
  ];

  exportUrlForType(type: ExportType) {
    return exportUrl(type, this.args.import);
  }
}
